import type { RegisterRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useRegister() {
  return useApiMutation(
    "post",
    "/auth/register",
    {
      notify: false,
      mapVariables: (data: RegisterRequestDto) => ({
        body: data,
        headers: {
          "x-auth-request": "true",
        },
      }),
    },
  );
}
